// Canonical OPIN participant-role vocabulary. This package declares the member
// list and nothing else: it sits below `@finnest/core` and below zod, so the
// schema (`OpinParticipantRole`), the stated default
// (`StatedOpinParticipantRole`) and the per-role decision record
// (`OpinParticipantRolePolicy`) all live one layer up in
// `@finnest/runtime-cd-contract`, which re-exports these symbols so infra/CLI
// importers are unchanged.
export const OPIN_PARTICIPANT_ROLES = ['receiver', 'transmitter', 'both'] as const;
export type OpinParticipantRole = (typeof OPIN_PARTICIPANT_ROLES)[number];
